<template>
  <b-row>
    <!-- Not part of D2P rundown, disabled for now -->
    <!-- <b-col cols="12">
      <b-card class="mb-2">
        <user-dashboard />
      </b-card>
    </b-col> -->
    <b-col cols="12">
      <b-card>
        <table-user />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BCard } from 'bootstrap-vue'
import TableUser from '@/views/admin/users/TableUser.vue'
// import UserDashboard from '@/views/admin/users/UserDashboard.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    TableUser,
    // UserDashboard,
  },

  data() {
    return {
      //
    }
  },

  mounted() {
    //
  },

  methods: {
    //
  },
}
</script>
